export const COMPANY = {
  name: "Konecta",
  fullName: "Konecta (Pty) Ltd",
  tagline: "AI Powered Technology & Digital Infrastructure Company",
  email: "marketing@konecta.co.za",
  phone: "068 336 2508",
  location: "152 14th Road, Noordwyk, Midrand, 1657",
  country: "South Africa",
  registrationNote: "All rights reserved",
  year: new Date().getFullYear(),
};

export const PAGE_SEO = {
  home: {
    title: null,
    description:
      "Konecta — Africa's premier telecoms & technology consultancy. We build networks, power data, and enable value-added services across the continent.",
  },
  platform: {
    title: "Our Platform",
    description:
      "Konecta's end-to-end value chain transforms connectivity into intelligent platforms that generate big data, analytics, and revenue.",
  },
  services: {
    title: "Our Services",
    description:
      "From wireless connectivity to AI-powered platforms — we build, deploy, and manage technology that empowers African businesses to connect, grow, and compete.",
  },
  microsoft: {
    title: "Microsoft Partnership",
    description:
      "As an authorised Microsoft Partner, Konecta delivers Azure, Microsoft 365, Copilot AI, and Dynamics 365 to African enterprises.",
  },
  events: {
    title: "Industry Events",
    description:
      "Konecta convenes Africa's most important technology conversations through three flagship events for CIOs, municipal leaders, and telecoms innovators.",
  },
  impact: {
    title: "Impact & Case Studies",
    description:
      "Real projects, measurable results. See how Konecta delivers transformative outcomes for Africa's leading organisations.",
  },
  insights: {
    title: "Insights & Thought Leadership",
    description:
      "Expert analysis on telecoms, AI adoption, Microsoft technologies, and digital strategy across Africa.",
  },
  about: {
    title: "About Konecta",
    description:
      "Africa's premier telecoms and technology consultancy — Level 1 B-BBEE certified, 100% women-owned, and a trusted Microsoft Partner.",
  },
  contact: {
    title: "Contact Us",
    description:
      "Get in touch with Konecta. Offices in Johannesburg, Cape Town, Dubai, and Mumbai. Let's build Africa's digital future together.",
  },
  wifiPlatform: {
    title: "Wi-Fi Platform",
    description:
      "Konecta's enterprise-grade Wi-Fi platform delivering connectivity, captive portals, and analytics across Africa.",
  },
  academy: {
    title: "Konecta Academy",
    description:
      "Accredited training programmes in AI, technopreneurship, and change management — upskilling Africa's digital workforce.",
  },
  privacyPolicy: {
    title: "Privacy Policy",
    description:
      "How Konecta collects, uses, shares and protects personal information across the Konecta Wi-Fi Portal, our website and related services — in line with POPIA and, where applicable, the GDPR.",
  },
};

export const OFFICES = [
  { city: "Johannesburg", tz: "Africa/Johannesburg", label: "Headquarters" },
  { city: "Cape Town", tz: "Africa/Johannesburg", label: "Regional Office" },
  { city: "Dubai", tz: "Asia/Dubai", label: "UAE Office" },
  { city: "Mumbai", tz: "Asia/Kolkata", label: "India Office" },
  { city: "London", tz: "Europe/London", label: "UK Office" },
];

export const FOOTER_SERVICES = [
  { label: "Wi-Fi-as-a-Service", to: "/wifi-platform" },
  { label: "Software & AI Services", to: "/software-digital" },
  { label: "Managed IT & Digital Media", to: "/managed-it" },
  { label: "Business Consulting", to: "/business-consulting" },
];

export const FOOTER_EVENTS = [
  { label: "CIO Konect Summit", to: "/events/cio-konect-summit-2025" },
  { label: "Municipal Indaba", to: "/events/municipal-indaba-2026" },
  { label: "All Events", to: "/events" },
  { label: "Sponsor an Event", to: "/contact" },
];

export const FOOTER_COMPANY = [
  { label: "Use Cases", to: "/insights#use-cases" },
  { label: "Insights", to: "/insights" },
  { label: "Partners & Clients", to: "/about#partners" },
  { label: "Yandisa Sokhanyile", to: "/about#leadership" },
];

export const BADGES = [
  "100% Women-Owned Enterprise",
  "POPIA Compliant",
  "Est. 2017 \u00b7 Midrand, South Africa",
];

export const HERO_STATS = [
  {
    text: "Level 1",
    label: "B-BBEE Certified",
    icon: "trophy",
    highlight: true,
  },
  { text: "Partner", label: "Microsoft", icon: "microsoft" },
  { end: 8, suffix: "+", label: "Years in Business", icon: "satellite" },
  { end: 100, suffix: "%", label: "Women-Owned", icon: "female" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80";

export const LEADERSHIP_DATA = {
  image: "/images/speakers/yandisa-sokhanyile.jpg",
  yearsExperience: "20+",
  name: "Yandisa Sokhanyile",
  title: "Founder & CEO, Konecta",
  tagline:
    "Telecoms & Digital Infrastructure Strategist \u00b7 Ecosystem Builder \u00b7 Purpose-Led Leader",
  bio: "Yandisa Sokhanyile is a telecoms and digital infrastructure strategist, ecosystem builder, and purpose-led leader shaping Africa\u2019s next phase of connectivity and economic inclusion. She has spent over two decades building platforms at the intersection of telecommunications, technology, media, and talent development.",
  bioExtended:
    "Known for bridging boardroom strategy with heart-led leadership, Yandisa champions a future where infrastructure is not just about access, but about dignity, opportunity, and economic participation. Her work spans public-private partnerships, advisory roles to government, CIO engagement platforms, and pan-African initiatives designed to move Africa from consumption to ownership in the digital economy.",
  quote:
    "Konecta has evolved into a technology company focused on building the intelligent infrastructure that powers Africa\u2019s digital future.",
  author: "Yandisa Sokhanyile, Founder & CEO, Konecta",
  recognition: [
    "Standard Bank Top Women Finalist",
    "Inspiring Fifty Women in Tech 2019",
    "Top 10 Tech Leaders to Watch \u2014 Insight Magazine",
    "Top 40 Women by Mail & Guardian",
    "Public Speaker \u00b7 Umhlobo Wenene FM",
    "Featured Voice on Digital Inclusion & Women in Technology",
  ],
};

export const CONTACT_SUBJECTS = [
  "Wi-Fi-as-a-Service",
  "Software & AI Services",
  "Managed IT & Digital Media Services",
  "Business Consulting",
  "Sponsor an Event",
  "Tender / Proposal Response",
  "Partnership Opportunity",
  "Speaking / Media Enquiry",
  "General Enquiry",
];

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Microsoft", path: "/microsoft" },
  { label: "Events", path: "/events" },
  { label: "Impact", path: "/impact" },
  { label: "Insights", path: "/insights" },
  { label: "Academy", path: "/academy" },
  { label: "About", path: "/about" },
];

export const CREDIBILITY_ITEMS = [
  {
    icon: "🏆",
    title: "Level 1 B-BBEE",
    desc: "Highest empowerment certification supporting inclusive economic participation",
  },
  {
    icon: "♀",
    title: "100% Women-Owned",
    desc: "Driving inclusive tech growth",
  },
  {
    icon: "microsoft",
    title: "Microsoft Partner",
    desc: "Azure, 365, AI & Dynamics deployments",
    isMicrosoft: true,
  },
  { icon: "🌍", title: "Pan-African Reach", desc: "Active in 12+ markets" },
  {
    icon: "📡",
    title: "TMT Specialist",
    desc: "Technology · Media · Telecoms",
  },
  {
    icon: "🎙️",
    title: "3 Industry Platforms",
    desc: "Flagship technology events convening Africa's leading digital decision-makers",
  },
];

export const TICKER_ITEMS = [
  "Wi-Fi-as-a-Service",
  "Software Services",
  "Managed IT Services",
  "Business Consulting",
  "100% Women-Owned",
  "Microsoft Partner",
  "AI Factory",
];

export const COUNTRIES = [
  { name: "South Africa", active: true },
  { name: "Kenya", active: true },
  { name: "Zambia", active: true },
  { name: "Zimbabwe", active: true },
  { name: "Tanzania", active: true },
  { name: "Mozambique", active: true },
  { name: "Nigeria", active: false, note: "Expanding" },
  { name: "Ghana", active: false, note: "Expanding" },
  { name: "Uganda", active: false, note: "Expanding" },
  { name: "Rwanda", active: false, note: "Expanding" },
];

export const SOCIAL_LINKS = [
  {
    label: "in",
    href: "https://www.linkedin.com/company/konectagroup/posts/?feedView=all",
    platform: "LinkedIn",
  },
  {
    label: "f",
    href: "https://web.facebook.com/profile.php?id=61565887414540",
    platform: "Facebook",
  },
  {
    label: "IG",
    href: "https://www.instagram.com/konecta_rsa?igsh=MWxhOHU0d2tldnFiaw==",
    platform: "Instagram",
  },
  {
    label: "▶",
    href: "https://www.youtube.com/@Konecta1",
    platform: "YouTube",
  },
];
